module.exports = __webpack_public_path__ + "static/img/9.6602160.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/sp/9.png
// module id = Qywk
// module chunks = 0